import React, { useEffect, useState } from "react";
import Request from "./components/Request";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchInvoice } from "../redux/invoice/action";
import useWallet from "../utils/hooks/useWalletConnect";
import { sendPayment } from "../redux/invoice/api";
import { toast } from "react-toastify";
import { pay, approveToken } from "../contract/helper";
import { RECEIPT_BRIDGE_CONTRACTS } from "../utils/constants";
import useSignature from "../utils/hooks/useSignature";
export default function Landing() {
  const { isConnected, connectWallet, account,chain,changeNetwork,isNetworkChangeSuccess } = useWallet();
  const { signature, nonce } = useSelector(({ user }) => user);
  const { getAuth, isSignIn, generateSignature } = useSignature();

  const [searchParams, setSearchParams] = useSearchParams();
  const [params, setParams] = useState("");
  const dispatch = useDispatch();
  useEffect(() => {
    setParams(searchParams.get("invoice"));
    if (searchParams.get("invoice")) {
      dispatch(fetchInvoice(searchParams.get("invoice")));
    }
  }, [searchParams]);
  const {
    invoice: { data, loading, error },
  } = useSelector(({ invoice }) => invoice);

  const sendPay = async (data) => {
    const payload = {
      $auth: getAuth,
      invoiceId: params,
      networkId: data?.networkId,
      token: data?.token,
    };

    try {
      const sendPaymentPromise = sendPayment(payload);
      toast.promise(sendPaymentPromise, {
        pending: "Initiating payment...",
        success: "Payment initiated successfully!",
        error: "Payment failed!",
      });

      sendPaymentPromise
        .then(({ data }) => {
          return contractPayment(data);
        })
        .catch((error) => {
          console.log(error);
          throw error;
        });
    } catch (error) {
      console.error("Error in sendPay: ", error);
    }
  };

  const contractPayment = async (args) => {
    try {
      const reciptientBridgeAddress = RECEIPT_BRIDGE_CONTRACTS[args?.networkId];
      // const res = await approveToken(account,reciptientBridgeAddress, args.payArgs);

      await toast.promise(
        approveToken(account, reciptientBridgeAddress, args.payArgs),
        {
          pending: "Approving token...",
          success: "Token approved successfully!",
          error: "Failed to approve token request!",
        }
      );

      await toast.promise(pay(account, reciptientBridgeAddress, args.payArgs), {
        pending: "Sending payment...",
        success: "Payment sent successfully!",
        error: "Failed to send payment!",
      });

      dispatch(fetchInvoice(searchParams.get("invoice")));
      
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="landing">
      <div className="landingIntro">
        <div className="landingIntro__image">
          <div className="landingIntro__top">
            <img src={process.env.PUBLIC_URL + "/images/top.png"} alt="top" />
          </div>
          <img
            className="landingIntro__img"
            src={process.env.PUBLIC_URL + "/images/landing.png"}
            alt="landing"
          />
          <div className="landingIntro__bot">
            <img src={process.env.PUBLIC_URL + "/images/bot.png"} alt="bot" />
          </div>
        </div>
        <div className="landingIntro__content">
          <div className="landingIntro__content-logo">
            <img src={process.env.PUBLIC_URL + "/images/logo.svg"} alt="logo" />
          </div>
          <h1>Enjoy our platform!</h1>
          <p className="xlg">
            Get paid in cryptocurrencies hassle-free with Paylink - simply
            connect your wallet and create multi-chain payment requests.
          </p>
          {!isConnected && (
            <button onClick={connectWallet} className="button primary">
              Connect Wallet
            </button>
          )}
        </div>
      </div>
      <div className="landingRequest" style={{display:'flex',justifyContent:'center'}}>
        <Request
          data={data}
          signature={signature}
          nonce={nonce}
          isConnected={isConnected}
          connectWallet={connectWallet}
          sendPay={sendPay}
          isSignIn={isSignIn}
          generateSignature={generateSignature}
          chain={chain}
          changeNetwork={changeNetwork}
          isNetworkChangeSuccess={isNetworkChangeSuccess}
        />
      </div>
    </div>
  );
}
